import { SocialStyled } from "../Style-components/Social.Styled";
import pdf from "../../assets/resume.pdf";

function Social() {
  return (
    <SocialStyled className="ab-br ">
      <p className="light pd-bt">//social</p>
      <div>
        <a
          href="mailto:reeturaj542@gmail.com?subject=Let's build something together"
          target="_blank"
          rel="noopener noreferrer"
        >
          <h4>gmail</h4>
          <p>reeturaj542@.com</p>
        </a>
        <a
          href="https://github.com/12otherWays"
          target="_blank"
          rel="noopener noreferrer"
        >
          <h4>github</h4>
          <p>https://github.com/12otherWays</p>
        </a>
        <a
          href="https://www.linkedin.com/in/reetu-raj-178434220/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <h4>linkedin</h4>
          <p>https://www.linkedin.com/in/reetu-raj-178434220/</p>
        </a>
        <a
          href="https://www.behance.net/reeturaj9812"
          target="_blank"
          rel="noopener noreferrer"
        >
          <h4>behance</h4>
          <p>https://www.behance.net/reeturaj9812</p>
        </a>
      </div>
      <span>
        <a href={pdf} download="reeturaj_resume">
          CV
        </a>
      </span>
    </SocialStyled>
  );
}

export default Social;
